'use strict';

var theme = {

    init: function () {
        this.trainingFilters();
        this.trainingLocationFilter();
        this.mobileTrainingFilterSticky();
        this.mobileOffcanvas();
        this.dropdownHover();
        this.scrollCue();
        this.swiperSlider();
        this.scrollToTabSection();
        this.breadcrumbHideOnScroll();
        this.languageSwitcher();
        this.ApplicationFormSetup();
        this.updateTrainingSidebar();
        this.tabsNavigation();
        this.smoothScrollToTop();
        this.loadMorePosts();
    },


    scrollToTabSection: function () {
        document.addEventListener('DOMContentLoaded', function () {
            const tabs = document.querySelectorAll('.nav-link');

            tabs.forEach(tab => {
                tab.addEventListener('click', function () {
                    if (window.innerWidth < 992) { // Adjust breakpoint as needed
                        const targetId = this.getAttribute('data-bs-target');
                        const targetSection = document.querySelector(targetId);

                        if (targetSection) {
                            targetSection.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        }
                    }
                });
            });
        });
    },

    breadcrumbHideOnScroll: function () {
        const breadcrumb = document.querySelector('.breadcrumb-nav');
        if (!breadcrumb) return;

        let lastScroll = 0;

        window.addEventListener('scroll', () => {
            const currentScroll = window.pageYOffset;

            if (currentScroll > lastScroll && currentScroll > 50) {
                breadcrumb.classList.add('breadcrumb-hidden');
            } else if (currentScroll < 350) {
                breadcrumb.classList.remove('breadcrumb-hidden');
            }

            lastScroll = currentScroll;
        });
    },

    /**
     * Training Filters
     * Handles AJAX filtering for training archive page
     */
    trainingFilters: () => {
        // Only run on training archive page
        if (!document.getElementById('training-results')) return;

        let isLoading = false;
        let currentFilters = {locations: [], durations: []};

        const errorMessage = training_ajax.error_message;
        const clearFiltersText = training_ajax.clear_filters_text;
        const loadMoreText = training_ajax.load_more_text;
        const loadingText = training_ajax.loading_text;
        const noResultsText = training_ajax.no_results_text;

        // Filter change events for checkboxes
        document.querySelectorAll('.filter-location-checkbox, .filter-duration-checkbox').forEach(checkbox => {
            checkbox.addEventListener('change', () => {
                loadTrainings(true);
            });
        });

        // Clear filters
        const clearButton = document.getElementById('clear-filters');
        if (clearButton) {
            clearButton.textContent = clearFiltersText; // Set localized text
            clearButton.addEventListener('click', function () {
                document.querySelectorAll('.filter-location-checkbox, .filter-duration-checkbox').forEach(checkbox => {
                    checkbox.checked = false;
                });
                loadTrainings(true);
            });
        }

        // Load more button event (using event delegation)
        document.addEventListener('click', function (e) {
            if (e.target && e.target.id === 'load-more-btn') {
                e.preventDefault();
                const button = e.target;
                const currentPage = parseInt(button.getAttribute('data-page'));
                const hasMore = button.getAttribute('data-has-more') === '1';

                if (hasMore && !isLoading) {
                    loadTrainings(false, currentPage);
                }
            }
        });

        function loadTrainings(replace = false, page = 1) {
            if (isLoading) return;

            isLoading = true;
            const loadingEl = document.getElementById('loading');
            const resultsEl = document.getElementById('training-results');

            if (replace) {
                loadingEl.style.display = 'block';
                loadingEl.textContent = loadingText;
                resultsEl.style.display = 'none';
            } else {
                // Show loading on button
                const loadMoreBtn = document.getElementById('load-more-btn');
                if (loadMoreBtn) {
                    loadMoreBtn.textContent = loadingText;
                    loadMoreBtn.disabled = true;
                }
            }

            // Get current filter values
            currentFilters.locations = Array.from(document.querySelectorAll('.filter-location-checkbox:checked'))
                .map(checkbox => checkbox.value);
            currentFilters.durations = Array.from(document.querySelectorAll('.filter-duration-checkbox:checked'))
                .map(checkbox => checkbox.value);

            const formData = new FormData();
            formData.append('action', 'filter_trainings');
            formData.append('locations', JSON.stringify(currentFilters.locations));
            formData.append('durations', JSON.stringify(currentFilters.durations));
            formData.append('page', page);
            formData.append('nonce', training_ajax.nonce);

            fetch(training_ajax.ajax_url, {
                method: 'POST',
                body: formData
            })
                .then(response => response.text())
                .then(data => {
                    loadingEl.style.display = 'none';

                    // Extract pagination data
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;
                    const paginationData = tempDiv.querySelector('.pagination-data');

                    let hasMore = false;
                    let currentPage = page;

                    if (paginationData) {
                        hasMore = paginationData.getAttribute('data-has-more') === '1';
                        currentPage = parseInt(paginationData.getAttribute('data-current-page'));
                        paginationData.remove();
                    }

                    const content = tempDiv.innerHTML;

                    if (replace) {
                        resultsEl.innerHTML = content || `<p>${noResultsText}</p>`; // Use localized no results text
                        resultsEl.style.display = 'block';

                        // Add load more button if needed
                        if (hasMore) {
                            const loadMoreContainer = document.createElement('div');
                            loadMoreContainer.className = 'load-more-container text-center mt-4';
                            loadMoreContainer.innerHTML = '<button id="load-more-btn" class="btn btn-primary" data-page="' + (currentPage + 1) + '" data-has-more="1">' + loadMoreText + '</button>';
                            resultsEl.appendChild(loadMoreContainer);
                        }
                    } else {
                        // Remove existing load more button
                        const existingLoadMore = document.querySelector('.load-more-container');
                        if (existingLoadMore) {
                            existingLoadMore.remove();
                        }

                        // Append new content
                        resultsEl.insertAdjacentHTML('beforeend', content);

                        // Add new load more button if needed
                        if (hasMore) {
                            const loadMoreContainer = document.createElement('div');
                            loadMoreContainer.className = 'load-more-container text-center mt-4';
                            loadMoreContainer.innerHTML = '<button id="load-more-btn" class="btn btn-primary" data-page="' + (currentPage + 1) + '" data-has-more="1">' + loadMoreText + '</button>';
                            resultsEl.appendChild(loadMoreContainer);
                        }
                    }

                    isLoading = false;
                })
                .catch(error => {
                    loadingEl.style.display = 'none';

                    // Reset load more button
                    const loadMoreBtn = document.getElementById('load-more-btn');
                    if (loadMoreBtn) {
                        loadMoreBtn.textContent = loadMoreText;
                        loadMoreBtn.disabled = false;
                    }

                    if (replace) {
                        resultsEl.innerHTML = `<p>${errorMessage}</p>`;
                        resultsEl.style.display = 'block';
                    }

                    isLoading = false;
                    console.error('Error:', error);
                });
        }
    },


    /**
     * Training Location Filter
     * Handles location filtering for training dates on single training pages
     */
    trainingLocationFilter: () => {
        const filterDropdown = document.getElementById('locationFilter');
        if (!filterDropdown) return;

        const dropdownItems = document.querySelectorAll('#locationFilter + .dropdown-menu .dropdown-item');
        const scheduleRows = Array.from(document.querySelectorAll('.schedule-row'));
        const showMoreBtn = document.getElementById('showMoreDates');
        const batch = 6;
        let currentVisible = batch;

        function updateRows(selectedLocation = 'all', reset = true) {
            let visibleRows = [];
            scheduleRows.forEach(row => {
                const rowLocation = row.getAttribute('data-location');
                if (selectedLocation === 'all' || rowLocation === selectedLocation) {
                    visibleRows.push(row);
                } else {
                    row.style.display = 'none';
                }
            });

            scheduleRows.forEach(row => row.style.display = 'none');
            visibleRows.slice(0, currentVisible).forEach(row => row.style.display = '');

            if (showMoreBtn) {
                showMoreBtn.style.display = visibleRows.length > currentVisible ? 'block' : 'none';
                showMoreBtn.onclick = function () {
                    currentVisible += batch;
                    updateRows(selectedLocation, false);
                };
            }
        }

        dropdownItems.forEach(item => {
            item.addEventListener('click', function (e) {
                e.preventDefault();
                const selectedLocation = this.getAttribute('data-location');
                currentVisible = batch;

                // Update button text while preserving the icon
                const buttonText = selectedLocation === 'all'
                    ? filterDropdown.getAttribute('data-default-text') || 'Location filter'
                    : this.textContent;
                const icon = filterDropdown.querySelector('i');
                filterDropdown.innerHTML = buttonText + ' ';
                if (icon) filterDropdown.appendChild(icon);

                updateRows(selectedLocation, true);
            });
        });

        // Initial state
        updateRows('all', true);
    },


    /**
     * Mobile Training Filter Sticky Behavior
     * Makes the location filter stick to bottom when training-dates section is visible on mobile
     */
    mobileTrainingFilterSticky: () => {
        const trainingDatesSection = document.getElementById('training-dates');
        const locationFilter = document.querySelector('.location-filter');

        if (!trainingDatesSection || !locationFilter) return;

        // Check if we're on mobile (Bootstrap lg breakpoint)
        const isMobile = () => window.innerWidth < 992;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (isMobile()) {
                    if (entry.isIntersecting) {
                        locationFilter.classList.add('fixed-to-bottom');
                    } else {
                        locationFilter.classList.remove('fixed-to-bottom');
                    }
                } else {
                    // Remove class on desktop
                    locationFilter.classList.remove('fixed-to-bottom');
                }
            });
        }, {
            threshold: 0.01 // Trigger when 10% of the section is visible
        });

        observer.observe(trainingDatesSection);

        // Handle window resize
        window.addEventListener('resize', () => {
            if (!isMobile()) {
                locationFilter.classList.remove('fixed-to-bottom');
            }
        });
    },


    /**
     * Language Switcher
     * Handles language dropdown toggle functionality
     */
    languageSwitcher: () => {
        const currentLangElements = document.querySelectorAll('.current-lang');
        const dropdowns = document.querySelectorAll('.language-dropdown');
        const languageSwitchers = document.querySelectorAll('.language-switcher');

        if (!currentLangElements.length || !dropdowns.length || !languageSwitchers.length) return;

        // Handle each language switcher independently
        languageSwitchers.forEach((switcher, index) => {
            const currentLang = switcher.querySelector('.current-lang');
            const dropdown = switcher.querySelector('.language-dropdown');

            if (!currentLang || !dropdown) return;

            // Toggle the dropdown visibility on click of the current language flag
            currentLang.addEventListener('click', function (event) {
                event.stopPropagation();

                // Close other dropdowns first
                dropdowns.forEach((otherDropdown, otherIndex) => {
                    if (otherIndex !== index) {
                        otherDropdown.style.display = 'none';
                    }
                });

                // Toggle current dropdown
                dropdown.style.display = (dropdown.style.display === 'flex') ? 'none' : 'flex';
            });
        });

        // Close all dropdowns when clicking outside any language switcher
        document.addEventListener('click', function (event) {
            const isInsideAnySwitcher = Array.from(languageSwitchers).some(switcher =>
                switcher.contains(event.target)
            );

            if (!isInsideAnySwitcher) {
                dropdowns.forEach(dropdown => {
                    dropdown.style.display = 'none';
                });
            }
        });
    },


    /**
     * Sub Menus
     * Enables multilevel dropdown
     */
    subMenu: () => {
        (function ($bs) {
            const CLASS_NAME = 'has-child-dropdown-show';
            $bs.Dropdown.prototype.toggle = function (_original) {
                return function () {
                    document.querySelectorAll('.' + CLASS_NAME).forEach(function (e) {
                        e.classList.remove(CLASS_NAME);
                    });
                    let dd = this._element.closest('.dropdown').parentNode.closest('.dropdown');
                    for (; dd && dd !== document; dd = dd.parentNode.closest('.dropdown')) {
                        dd.classList.add(CLASS_NAME);
                    }
                    return _original.call(this);
                }
            }($bs.Dropdown.prototype.toggle);
            document.querySelectorAll('.dropdown').forEach(function (dd) {
                dd.addEventListener('hide.bs.dropdown', function (e) {
                    if (this.classList.contains(CLASS_NAME)) {
                        this.classList.remove(CLASS_NAME);
                        e.preventDefault();
                    }
                    e.stopPropagation();
                });
            });
        })(bootstrap);
    },

    /**
     * Dropdown Hover for Desktop
     * Enables hover dropdown for desktop, keeps click for mobile
     */
    dropdownHover: () => {
        const dropdowns = document.querySelectorAll('.navbar .dropdown');

        dropdowns.forEach(dropdown => {
            const toggle = dropdown.querySelector('.dropdown-toggle');
            const menu = dropdown.querySelector('.dropdown-menu');

            if (!toggle || !menu) return;

            // Only apply hover on desktop (lg and up)
            const applyHover = () => window.innerWidth >= 992;

            // Prevent click on desktop - use capture phase to intercept before Bootstrap
            toggle.addEventListener('click', (e) => {
                if (applyHover()) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    return false;
                }
            }, true); // Use capture phase

            // Also prevent the default Bootstrap data-bs-toggle behavior on desktop
            if (applyHover()) {
                toggle.removeAttribute('data-bs-toggle');
            }

            dropdown.addEventListener('mouseenter', () => {
                if (applyHover()) {
                    const bsDropdown = bootstrap.Dropdown.getOrCreateInstance(toggle);
                    bsDropdown.show();
                }
            });

            dropdown.addEventListener('mouseleave', () => {
                if (applyHover()) {
                    const bsDropdown = bootstrap.Dropdown.getInstance(toggle);
                    if (bsDropdown) {
                        bsDropdown.hide();
                    }
                }
            });

            // Re-add data-bs-toggle on resize to mobile
            window.addEventListener('resize', () => {
                if (applyHover()) {
                    toggle.removeAttribute('data-bs-toggle');
                } else {
                    toggle.setAttribute('data-bs-toggle', 'dropdown');
                }
            });
        });
    },




    /**
     * Mobile Offcanvas Navigation
     * Handles dual offcanvas navigation for mobile with submenu support
     */
    mobileOffcanvas: () => {
        // Get references to both offcanvas instances
        const mainOffcanvas = new bootstrap.Offcanvas(document.getElementById('offcanvasNavbar'));
        const submenuOffcanvas = new bootstrap.Offcanvas(document.getElementById('offcanvasSubmenu'));

        // Get the navbar toggler button
        const navbarToggler = document.querySelector('.navbar-toggler');

        // Flag to track transitions between offcanvas panels
        let isTransitioning = false;

        // Intercept the toggle button click
        navbarToggler.addEventListener('click', function (e) {
            // If submenu is open, prevent default and close everything
            if (document.getElementById('offcanvasSubmenu').classList.contains('show')) {
                e.preventDefault();
                e.stopPropagation();

                // Hide both offcanvas panels
                submenuOffcanvas.hide();
                mainOffcanvas.hide();

                // Reset toggler state
                setTimeout(() => {
                    navbarToggler.setAttribute('aria-expanded', 'false');
                    isTransitioning = false;
                }, 300);

                return false;
            }
        });

        // Listen for offcanvas show/hide events to sync the hamburger icon state
        document.getElementById('offcanvasNavbar').addEventListener('hidden.bs.offcanvas', function () {
            // Only set to false if submenu is also closed AND we're not transitioning
            if (!document.getElementById('offcanvasSubmenu').classList.contains('show') && !isTransitioning) {
                navbarToggler.setAttribute('aria-expanded', 'false');
            }
        });

        document.getElementById('offcanvasNavbar').addEventListener('shown.bs.offcanvas', function () {
            navbarToggler.setAttribute('aria-expanded', 'true');
            isTransitioning = false;
        });

        // Add events for submenu offcanvas
        document.getElementById('offcanvasSubmenu').addEventListener('shown.bs.offcanvas', function () {
            navbarToggler.setAttribute('aria-expanded', 'true');
            isTransitioning = false;
        });

        document.getElementById('offcanvasSubmenu').addEventListener('hidden.bs.offcanvas', function () {
            // Only set to false if main nav is also closed AND we're not transitioning
            if (!document.getElementById('offcanvasNavbar').classList.contains('show') && !isTransitioning) {
                navbarToggler.setAttribute('aria-expanded', 'false');
            }
        });

        // Handle parent menu items with dropdown class
        const parentItems = document.querySelectorAll('#offcanvasNavbar .dropdown > a');

        parentItems.forEach(item => {
            item.addEventListener('click', function (e) {
                // Only handle for mobile view
                if (window.innerWidth < 992) {
                    e.preventDefault();

                    // Get the submenu
                    const submenu = this.nextElementSibling;
                    // Update the submenu title
                    document.getElementById('offcanvasSubmenuLabel').textContent = this.textContent.trim();

                    // Clone the submenu items to the secondary offcanvas
                    const submenuContainer = document.getElementById('submenuContainer');
                    submenuContainer.innerHTML = '';
                    submenuContainer.appendChild(submenu.cloneNode(true));

                    // Set transitioning flag to prevent icon state change
                    isTransitioning = true;

                    // Hide main offcanvas and show submenu offcanvas
                    mainOffcanvas.hide();

                    setTimeout(() => {
                        submenuOffcanvas.show();
                    }, 400);
                }
            });
        });

        // Back button functionality
        document.querySelector('.back-to-main').addEventListener('click', function () {
            // Set transitioning flag to prevent icon state change
            isTransitioning = true;

            submenuOffcanvas.hide();
            setTimeout(() => {
                mainOffcanvas.show();
            }, 300);
        });
    },


    scrollCue: () => {
        scrollCue.init({
            interval: -400,
            duration: 700,
            percentage: 0.8
        });
        scrollCue.update();
    },
    /**
     * Swiper Slider
     * Enables carousels and sliders
     * Requires assets/js/vendor/swiper-bundle.min.js
     */
    swiperSlider: function () {

        // Initialize partners swiper
        const partnersClients = document.querySelector('.swiper-partners-clients');

        if (partnersClients && typeof Swiper !== 'undefined') {
            try {
                const swiper = new Swiper(".swiper-partners-clients", {
                    slidesPerView: 4,
                    spaceBetween: 60,
                    loop: true,
                    centeredSlides: false,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false
                    },
                    speed: 3000,
                    freeMode: false,
                    allowTouchMove: false,
                    grabCursor: false,
                    breakpoints: {
                        480: {
                            slidesPerView: 6,
                            spaceBetween: 50,
                        },
                        768: {
                            slidesPerView: 7
                        },
                        1200: {
                            slidesPerView: 8
                        },
                        1920: {
                            slidesPerView: 12
                        }
                    },
                });

                // Restart autoplay if it stops
                swiper.on('slideChangeTransitionEnd', () => {
                    if (!swiper.autoplay.running) {
                        swiper.autoplay.start();
                    }
                });

                swiper.on('autoplayStop', () => {
                    if (!swiper.autoplay.running) {
                        swiper.autoplay.start();
                    }
                });

            } catch (error) {
                console.error('Error initializing Swiper:', error);
            }
        }


        // Initialize news swiper
        const swiperNewsElement = document.querySelector('.swiper-news');

        if (swiperNewsElement && typeof Swiper !== 'undefined') {
            try {
                const swiperNews = new Swiper('.swiper-news', {
                    slidesPerView: 1,
                    spaceBetween: 24,
                    loop: false,
                    pagination: {
                        el: '.swiper-news .swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        }
                    }
                });
            } catch (error) {
                console.error('Error initializing News Swiper:', error);
            }
        }


        // Initialize training overview Swiper
        const trainingOverviewElement = document.querySelector('.training-overview.swiper-container');

        if (trainingOverviewElement && typeof Swiper !== 'undefined') {
            try {
                const trainingSwiper = new Swiper('.training-overview.swiper-container', {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    pagination: {
                        el: '.swiper-pagination.training-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 40,
                        },
                    },
                });
            } catch (error) {
                console.error('Error initializing Training Overview Swiper:', error);
            }
        }


        // // Initialize LinkedIn Swiper
        const swiperLinkedInFeed = document.querySelector('.swiper-linkedin-feed');

        if (swiperLinkedInFeed && typeof Swiper !== 'undefined') {
            try {
                const swiperLinkedInFeed = new Swiper('.swiper-linkedin-feed', {
                    slidesPerView: 1,
                    spaceBetween: 24,
                    loop: false,
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        }
                    }
                });
            } catch (error) {
                console.error('Error initializing News Swiper:', error);
            }
        }

    },


    tabsNavigation: function () {
        document.addEventListener('DOMContentLoaded', function () {
            const tabsContainer = document.querySelector('#courseTab, #pageTab');
            const tabs = tabsContainer ? tabsContainer.querySelectorAll('.nav-link') : [];

            const tabsNavigation = document.querySelector('.tabs-navigation');
            if (tabs.length <= 1 && tabsNavigation) {
                tabsNavigation.classList.add('hidden');
            }

            const prevButton = document.getElementById('prevTab');
            const nextButton = document.getElementById('nextTab');
            const menu = document.querySelector('.course-menu') || document.querySelector('.page-menu');

            if (!tabs.length || !prevButton || !nextButton || !menu) return;

            if (tabs.length <= 1) {
                prevButton.style.display = 'none';
                nextButton.style.display = 'none';
                menu.style.display = 'none';
                return;
            }

            function updateButtons() {
                const activeIndex = [...tabs].findIndex(tab => tab.classList.contains('active'));
                prevButton.disabled = activeIndex === 0;
                nextButton.disabled = activeIndex === tabs.length - 1;

                prevButton.classList.toggle('disabled', prevButton.disabled);
                nextButton.classList.toggle('disabled', nextButton.disabled);
            }

            function activateTab(index) {
                tabs[index].click();
                const targetId = tabs[index].getAttribute('data-bs-target');
                const targetSection = document.querySelector(targetId);

                if (targetSection) {
                    targetSection.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }

                if (window.innerWidth >= 992) {
                    menu.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }

            prevButton.addEventListener('click', () => {
                const activeIndex = [...tabs].findIndex(tab => tab.classList.contains('active'));
                if (activeIndex > 0) {
                    activateTab(activeIndex - 1);
                }
            });

            nextButton.addEventListener('click', () => {
                const activeIndex = [...tabs].findIndex(tab => tab.classList.contains('active'));
                if (activeIndex < tabs.length - 1) {
                    activateTab(activeIndex + 1);
                }
            });

            tabs.forEach(tab => tab.addEventListener('shown.bs.tab', updateButtons));

            updateButtons();
        });
    },




    smoothScrollToTop: function () {
        document.addEventListener('DOMContentLoaded', function () {
            const scrollToTopButton = document.getElementById('scrollToTop');

            if (!scrollToTopButton) return;

            scrollToTopButton.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });

            window.addEventListener('scroll', () => {
                if (window.scrollY > 300) {
                    scrollToTopButton.classList.add('visible');
                } else {
                    scrollToTopButton.classList.remove('visible');
                }
            });
        });
    },


    /**
     * GLightbox
     * Enables lightbox functionality
     * Requires assets/js/vendor/glightbox.js
     */

    lightbox: () => {
        const lightbox = GLightbox({
            selector: '*[data-glightbox]',
            touchNavigation: true,
            loop: false,
            zoomable: false,
            autoplayVideos: true,
            moreLength: 0,
            slideExtraAttributes: {
                poster: ''
            },
            plyr: {
                css: '',
                js: '',
                config: {
                    ratio: '',
                    fullscreen: {
                        enabled: false,
                        iosNative: false
                    },
                    youtube: {
                        noCookie: true,
                        rel: 0,
                        showinfo: 0,
                        iv_load_policy: 3
                    },
                    vimeo: {
                        byline: false,
                        portrait: false,
                        title: false,
                        transparent: false
                    }
                }
            },
        });
    },


    /**
     * Wrap Gravity Forms fields in sign-up-box
     * Wraps fields between sign-up-box-start and sign-up-box-end markers
     */
    ApplicationFormSetup: function () {
        const executeWrapping = () => {
            const gformBody = document.querySelector('#gform_3 .gform-body');

            if (!gformBody) return;

            // Replace <legend> with <label> inside the form
            const legends = gformBody.querySelectorAll('legend');
            legends.forEach(legend => {
                const label = document.createElement('label');
                label.innerHTML = legend.innerHTML;
                Array.from(legend.attributes).forEach(attr => {
                    label.setAttribute(attr.name, attr.value);
                });
                legend.parentNode.replaceChild(label, legend);
            });

            // Wrap fields in specified ranges
            const wrapFields = (startFieldId, endFieldId, wrapperClass) => {
                const startField = document.getElementById(startFieldId);
                const endField = document.getElementById(endFieldId);

                if (!startField || !endField) return;

                const wrapper = document.createElement('div');
                wrapper.className = wrapperClass;

                startField.parentNode.insertBefore(wrapper, startField);

                let currentElement = startField;
                while (currentElement && currentElement.id !== endFieldId) {
                    const nextSibling = currentElement.nextSibling;
                    wrapper.appendChild(currentElement);
                    currentElement = nextSibling;
                }

                if (currentElement && currentElement.id === endFieldId) {
                    wrapper.appendChild(currentElement);
                }
            };

            wrapFields('field_3_19', 'field_3_9', 'sign-up-box');
            wrapFields('field_3_15', 'field_3_12', 'invoice-box');
            wrapFields('field_3_26', 'field_submit', 'submit-button-box');

        };

        const waitForGForm = () => {
            const gform = document.getElementById('gform_3');
            const gformBody = document.querySelector('#gform_3 .gform-body');
            const startField = document.getElementById('field_3_19');
            const endField = document.getElementById('field_3_9');

            if (gform && gformBody && startField && endField) {
                executeWrapping();
            } else {
                setTimeout(waitForGForm, 100);
            }
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', waitForGForm);
        } else {
            waitForGForm();
        }

        document.addEventListener('gform_post_render', function (event) {
            if (event.detail && event.detail.formId === 3) {
                executeWrapping();
            }
        });
    },


    updateTrainingSidebar: function () {
        document.addEventListener('DOMContentLoaded', function () {
            const trainingSelect = document.getElementById('input_3_19_1');
            const selectedTrainingContainer = document.querySelector('.selected-training');

            // Function to fetch and update training data
            const fetchTrainingData = (trainingID) => {
                if (trainingID) {

                    // Get current language code (e.g., 'nl' from 'nl-NL')
                    const currentLang = document.documentElement.lang.split('-')[0];

                    // Append lang query parameter so Polylang knows the context
                    fetch(`/wp-json/csd/v1/training/${trainingID}?lang=${currentLang}`)
                        .then(response => response.json())
                        .then(data => {
                            if (!data.code) {
                                selectedTrainingContainer.innerHTML = `
                                <div class="single-training-inner">
                                    <div class="img-box">
                                        <img src="${data.image}" class="img-fit" width="180" height="156" alt="${data.title}">
                                    </div>
                                    <div class="content-box">
                                        <div class="single-training-data">
                                            <h4 class="training-title">${data.title}</h4>
                                            <p class="training-description">${data.summary}</p>
                                            <div class="training-info">
                                                <p class="training-location"><span class="location location-icon">${data.location}</span></p>
                                                <p class="training-duration"><span class="duration duration-icon">${data.duration}</span></p>
                                                <p class="training-price"><span class="price pricing-icon">${data.price}</span></p>
                                            </div>
                                            <div class="go-to-training">
                                                <a href="${data.link}" class="btn btn-orange" aria-label="Go to ${data.title}"><i class="fa-whiteboard fa-semibold fa-arrow-right"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            `;
                            } else {
                                selectedTrainingContainer.innerHTML = `<p class="text-primary mb-0 p-4">${data.message || 'Training not found.'}</p>`;
                            }
                        })
                        .catch(error => {
                            console.error('Error:', error);
                            selectedTrainingContainer.innerHTML = `<p class="text-primary mb-0">Error loading training details.</p>`;
                        });
                }
            };

            // Handle initial load if trainingID is in the URL or dropdown has a default value
            if (typeof initialTrainingID !== 'undefined' && initialTrainingID) {
                fetchTrainingData(initialTrainingID);
            } else if (trainingSelect && trainingSelect.value) {
                fetchTrainingData(trainingSelect.value);
            }

            // Handle dropdown changes
            if (trainingSelect) {
                trainingSelect.addEventListener('change', function () {
                    const trainingID = trainingSelect.value;
                    fetchTrainingData(trainingID);
                });
            }
        });
    },



    // Add this new method for load more functionality
    loadMorePosts: function() {
        document.addEventListener('DOMContentLoaded', function() {
            const loadMoreButton = document.getElementById('load-more-posts');

            if (!loadMoreButton) return;

            loadMoreButton.addEventListener('click', function() {
                const button = this;
                const currentPage = parseInt(button.dataset.page);
                const maxPages = parseInt(button.dataset.max);
                const lang = button.dataset.lang;
                const ajaxurl = typeof app_vars !== 'undefined' ? app_vars.ajaxurl : '/wp-admin/admin-ajax.php';
                const i18n = (typeof app_vars !== 'undefined' && app_vars.i18n) ? app_vars.i18n : {};
                const loadMoreLabel = i18n.load_more || button.textContent;
                const loadingLabel = i18n.loading || 'Loading...';

                // Remove the button reliably. Its wrapper uses Bootstrap's
                // `.d-flex` (display:flex !important), so an inline display:none
                // would be ignored. Removing the row avoids that entirely.
                const removeLoadMore = function () {
                    const row = button.closest('.row');
                    if (row) {
                        row.remove();
                    } else {
                        button.style.setProperty('display', 'none', 'important');
                    }
                };

                // Prevent multiple clicks
                if (button.classList.contains('loading')) return;

                button.classList.add('loading');
                button.textContent = loadingLabel;

                const formData = new FormData();
                formData.append('action', 'csd_load_more');
                formData.append('page', currentPage);
                formData.append('lang', lang);

                fetch(ajaxurl, {
                    method: 'POST',
                    body: formData
                })
                    .then(response => response.text())
                    .then(data => {
                        const html = (data || '').trim();

                        if (html) {
                            // Append new posts
                            const container = document.getElementById('news-grid-container');
                            if (container) {
                                container.insertAdjacentHTML('beforeend', html);
                            }

                            // Update page count
                            const newPage = currentPage + 1;
                            button.dataset.page = newPage;

                            // Reached the last page: remove the button
                            if (newPage >= maxPages) {
                                removeLoadMore();
                            }
                        } else {
                            // Server returned nothing: no more posts
                            removeLoadMore();
                        }
                    })
                    .catch(error => {
                        console.error('Error loading posts:', error);
                    })
                    .finally(() => {
                        // Always clear the loading state so the button can
                        // never get stuck on "Loading..." with no results.
                        button.classList.remove('loading');
                        button.textContent = loadMoreLabel;
                    });
            });
        });
    },


}
theme.init();


function GetURLParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) {
            return sParameterName[1];
        }
    }
}
